document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const heroSection = document.querySelector(".primary-hero");
  if (!heroSection) {
    return;
  }

  const scrollTriggerAvailable =
    typeof ScrollTriggerUtils !== "undefined" && ScrollTriggerUtils.register();

  const heroFgIcons = heroSection.querySelectorAll(
    ".hero-icons .floating-icon"
  );

  if (heroFgIcons.length > 0) {
    heroFgIcons.forEach((icon) => {
      gsap.set(icon, {
        transformOrigin: "center center",
        scale: 0.8,
        opacity: 0,
      });
      gsap.to(icon, {
        opacity: 1,
        scale: 1,
        duration: 2,
        ease: "back.out(1.2)",
        delay: Math.random() * 0.4,
        force3D: true,
      });
    });

    if (scrollTriggerAvailable) {
      heroFgIcons.forEach((icon, index) => {
        const speeds = [0.2, 0.3, 0.4, 0.4, 0.3, 0.2];
        const speed = speeds[index % speeds.length];
        gsap.to(icon, {
          y: -300 * speed,
          ease: "none",
          scrollTrigger: {
            trigger: heroSection,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true,
          },
        });
      });
    }
  }

  const heroBgContainer = heroSection.querySelector(".hero-icons-bg");
  const heroBgIcons = heroSection.querySelectorAll(
    ".hero-icons-bg .floating-icon"
  );

  if (heroBgContainer && heroBgIcons.length > 0) {
    gsap.to(heroBgContainer, {
      opacity: 1,
      duration: 1.5,
      ease: "power2.out",
      delay: 0.3,
    });

    if (scrollTriggerAvailable) {
      heroBgIcons.forEach((icon, index) => {
        const speeds = [0.1, 0.15, 0.12, 0.18, 0.13, 0.16];
        const speed = speeds[index % speeds.length];
        gsap.to(icon, {
          y: -220 * speed,
          ease: "none",
          scrollTrigger: {
            trigger: heroSection,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true,
          },
        });
      });
    }
  }

  const logoItems = heroSection.querySelectorAll(
    ".primary-hero__logos-wrapper .primary-hero__logo-item"
  );

  if (logoItems.length > 0) {
    gsap.to(logoItems, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.out",
      stagger: 0.1,
      delay: 0,
    });
  }
});
